import type { ChartDataItem } from 'utils/chart-options';

export const findStackedAreaFieldAtY = (
  dataPoint: ChartDataItem,
  chartFields: string[],
  totalTooltipField: string | undefined,
  dataY: number,
): string | null => {
  let positiveCumulative = 0;
  let negativeCumulative = 0;

  for (const field of chartFields) {
    if (field === totalTooltipField) continue;

    const value = dataPoint[field];
    if (typeof value !== 'number' || value === 0) continue;

    const previousCumulative = value < 0 ? negativeCumulative : positiveCumulative;
    const currentCumulative = previousCumulative + value;
    const bandMin = Math.min(previousCumulative, currentCumulative);
    const bandMax = Math.max(previousCumulative, currentCumulative);

    if (dataY >= bandMin && dataY <= bandMax) return field;

    if (value < 0) negativeCumulative = currentCumulative;
    else positiveCumulative = currentCumulative;
  }

  return null;
};
